import { render } from "./menu.vue?vue&type=template&id=a3a73470&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=a3a73470&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a3a73470"

export default script